import { useQuery } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { callsKeys } from '../../cache-keys/callsKeys';
import { MarketCountryCode } from '@axo/shared/types';

export function useCallTags(
  marketCountry?: MarketCountryCode,
  userRoles?: string[],
) {
  const api = useAPI();
  const cacheKey = callsKeys.tags(marketCountry, userRoles);

  return useQuery({
    queryKey: [cacheKey, marketCountry, userRoles],
    queryFn: ace_api.getCallTags(api),
    enabled:
      api.token.length > 0 &&
      marketCountry !== undefined &&
      userRoles !== undefined,
    select: ({ Items }) =>
      Items?.filter(
        (tag) =>
          tag.MarketCountry === marketCountry &&
          !tag.Disabled &&
          tag.Roles?.some((role) => userRoles?.includes(role)),
      ) ?? [],
  });
}
